import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCustomStackoverflow = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		fill='currentColor'
		viewBox='0 0 24 24'
		width='1em'
		height='1em'
		className='svg-icon'
		{...props}>
		<path d='M17.36 20.2v-9.21h3.04l.46-3.54h-3.5V5.5c0-1.02.28-1.72 1.75-1.72h1.87V.58A25 25 0 0 0 18.26.5c-2.65 0-4.47 1.62-4.47 4.6v2.61H10.7v3.54h3.08v9.21h3.58zm-8.9-2.39a6.85 6.85 0 0 0 3.18-1.32l-1.42-1.42a4.5 4.5 0 0 1-1.76.54v-3.67h3.14V10.1H8.46V6.8H6.1v3.3H4v1.84h2.1v3.86c0 2.57 1.85 4.2 4.36 4.2z' />
	</svg>
);
export default SvgCustomStackoverflow;
